import type { WrappedReducer } from 'client/js/redux/types/ReduxAsyncActions.types';
import type { FileIngestorState } from 'client/js/redux/domains/FileIngestor/FileIngestor.types';
import type { FileIngestorAction } from 'client/js/redux/domains/FileIngestor/actions';
import { GET_JOB_BY_ID, GET_JOBS, TRIGGER_JOB, UPLOAD_FILE } from 'client/js/redux/domains/FileIngestor/actions';
import { ReduxAsyncActionsService } from 'client/js/redux/services/ReduxAsyncActions.service';
import { INIT_STATE } from 'client/js/redux/domains/FileIngestor/FileIngestor.constants';
import { LOADING_STATUS } from 'client/js/main/support/constants';
import { CLEAR_JOB_DETAILS } from 'client/js/redux/domains/FileIngestor/actions/clearJobDetails';
import { QUICK_VALIDATE } from 'client/js/redux/domains/FileIngestor/actions/quickValidate.action';

const Handler = (
  state: WrappedReducer<FileIngestorState>,
  action: FileIngestorAction
): WrappedReducer<FileIngestorState> => {
  switch (action.type) {
    case TRIGGER_JOB.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    case UPLOAD_FILE.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
        fileUri: action.data.fileUri,
      };
    case GET_JOBS.response:
      return {
        ...state,
        loading: false,
        jobs: action.data.data,
        pagination: action.data.pagination,
      };
    case GET_JOB_BY_ID.response:
      return {
        ...state,
        jobDetails: action.data,
      };
    case CLEAR_JOB_DETAILS:
      return { ...state, jobDetails: null };
    case QUICK_VALIDATE.response:
      return {
        ...state,
        loadingStatus: LOADING_STATUS.LOADED,
        loading: false,
      };
    default:
      return state;
  }
};

const FileIngestorReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, Handler, {
  request: [TRIGGER_JOB, UPLOAD_FILE, GET_JOBS, QUICK_VALIDATE],
  error: [TRIGGER_JOB, UPLOAD_FILE, GET_JOBS, QUICK_VALIDATE],
});

export default FileIngestorReducer;
